module.exports = __webpack_public_path__ + "img/GB7.12b86e72.jpg";